import { useLayoutEffect } from "react";

export function useAutoScrollToBottom(
  ref: React.RefObject<HTMLDivElement | null>,
  deps: any[] = [],
) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;

    const scrollToLastItemStart = () => {
      // On veut voir le début du dernier élément (ex: formulaire long)
      const last = el.lastElementChild as HTMLElement | null;

      if (last) {
        // Scroll vers le haut du dernier élément
        // (block: "start" = aligner le haut de l'élément avec le haut du conteneur)
        last.scrollIntoView({ block: "start" });
      } else {
        // Fallback
        el.scrollTop = el.scrollHeight;
      }
    };

    // Double RAF pour laisser le temps au DOM/layout de se stabiliser
    requestAnimationFrame(() => {
      scrollToLastItemStart();
      requestAnimationFrame(scrollToLastItemStart);
    });
  }, deps);
}
